// extracted by mini-css-extract-plugin
module.exports =  {"image":"TdS5Lxo","loading-image":"yfIYjtW","loadingImage":"yfIYjtW"};